export default __webpack_public_path__ + "static/subscription-journey-lifecycle-8e9d850038eeb6cab19d36d091904d13.svg";